import React from 'react';
import styled from 'styled-components';
import { colorThemeGenerator, ButtonPrimary, Type } from '@spotify-internal/encore-creator-web';
import { spacer32, screenMdMin, gray10, aquamarine } from '@spotify-internal/encore-foundation';
import { TextWithDesktopLineBreak } from '../Shared/TextWithDesktopLineBreak';
import { pageConstraintStyles, PAGE_GUTTER } from './styles';
import { useMe } from '../../hooks/useMe';
import { FormattedMessage } from 'react-intl';
import { login } from '../../lib/Request';

export function Hero() {
  const me = useMe();

  return (
    <HeroContainer>
      <HeroText variant={Type.display1}>
        <FormattedMessage
          id="landing-page.hero.reach-a-world"
          defaultMessage="Reach a world {break} of new listeners"
          values={{ break: <br /> }}
        />
      </HeroText>
      <Type as="h2" variant={Type.heading4} style={{ margin: `${spacer32} 0 18px` }}>
        <FormattedMessage
          id="landing-page.hero.you-make-podcasts"
          defaultMessage="You make podcasts. We make it easier for millions of people to find and listen to them."
        />
        <TextWithDesktopLineBreak as="span" variant={Type.heading4}>
          <FormattedMessage
            id="landing-page.hero.get-your-show"
            defaultMessage="Get your show on Spotify, and see the data and insights you need to grow your audience."
          />
        </TextWithDesktopLineBreak>
      </Type>

      <ButtonPrimary
        onClick={login}
        theme={{
          ...colorThemeGenerator({
            primaryColor: aquamarine,
            primaryColorText: gray10,
            primaryColorFocusText: gray10,
            primaryColorActiveText: gray10,
          }),
        }}
        buttonSize={ButtonPrimary.lg}
      >
        {me ? (
          <FormattedMessage id="landing-page.hero.your-dashboard" defaultMessage="Your Dashboard" />
        ) : (
          <FormattedMessage id="landing-page.hero.get-started" defaultMessage="Get Started" />
        )}
      </ButtonPrimary>
    </HeroContainer>
  );
}

const HeroContainer = styled.div`
  padding: 80px 15px;

  @media (min-width: ${screenMdMin}) {
    ${pageConstraintStyles}

    padding: 80px 0 92px ${PAGE_GUTTER};
  }
  @media (max-width: 1100px) and (min-width: ${screenMdMin}) {
    padding-left: 15px;
  }
`;

const HeroText = styled(Type).attrs({
  forwardedAs: 'h1',
})`
  font-size: 48px;
  line-height: 52px;
  padding: 0;

  @media (min-width: ${screenMdMin}) {
    font-size: 120px;
    line-height: 110px;
    padding: 0;
  }
`;
